export default __webpack_public_path__ + "static/media/BOD Regular Meeting January 17, 2020.31f9352e.pdf";